module.exports = __webpack_public_path__ + "static/img/4102_phase_function_Paper_PointsHejduk_Prediction.e80c8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4102_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0HT3
// module chunks = 0